module.exports = __webpack_public_path__ + "static/media/Murugappa_Group_Logo.svg.4cff91bd.png";